var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"e-input-group e-control-wrapper e-multi-line-input"},[_c('textarea',_vm._g(_vm._b({ref:"input",staticClass:"input-textarea",style:({
       resize: _vm.resize ? '' : 'none' ,
       height: _vm.height ? (_vm.height + "px !important") : null
    }),attrs:{"spellcheck":"false","autocomplete":"off"}},'textarea',_vm.inputAttributes,false),_vm.inputListeners),[_vm._v(" <slot/> ")])])}
var staticRenderFns = []

export { render, staticRenderFns }